/**
 * Class to handle active waits. The function initialize creates the timer that, in turn, returns a promise. Awaiting on that promise
 allows to actively wait for the completion. This promise returns the object that made checkFun to return true. Receives 3 arguments:
 * @param {function} runFun Function to run every timeout, should return the object that will be checked by checkFun
 * @param {function} checkFun receives an object as a parameter and has return true if the wait has finished, or false if not
 * @param {number} timeout milliseconds to run runFun
 * @param {Array} runFunArgs Arguments for runFun, by default is an empty object
 * @param {Array} checkFunArgs Arguments for checkFun, after the object returned by runFun. By default is an empty object.
 */
export class ActiveWaiter {
  constructor(runFun, checkFun, timeout, runFunArgs = [], checkFunArgs = []) {
    this.runFun = runFun;
    this.checkFun = checkFun;
    this.timeout = timeout;
    this.runFunArgs = runFunArgs;
    this.checkFunArgs = checkFunArgs;
    this.stop = false;
  }

  handler(resolve, reject) {
    try {
      const output = this.runFun(...this.runFunArgs);
      const result = this.checkFun(output, ...this.checkFunArgs);
      Promise.resolve(result).then((ok) => {
        if (ok) {
          this.stop = true;
          resolve(output);
        }
      }).catch((asyncError) => {
        if (asyncError) {
          this.stop = true;
          reject(asyncError);
        }
      });
    } catch (syncError) {
      this.stop = true;
      reject(syncError);
    }
  }

  loop(resolve, reject) {
    if (!this.stop) {
      this.handler(resolve, reject);
      this.refreshId = setTimeout(() => {
        this.loop(resolve, reject);
      }, this.timeout);
    } else {
      resolve();
    }
  }

  initialize() {
    return new Promise((resolve, reject) => {
      this.loop(resolve, reject);
    });
  }

  forceClear() {
    clearTimeout(this.refreshId);
    this.stop = true;
  }
}
